<template lang="pug">
div
	h1 {{contentpage.name}}
	ws-content(:value="contentpage.content")
		template(slot="forecast")
			forecast-table(:areaslug="resort.area.slug" :initial-active-resort-id="resort.id")
		template(slot="weblog" v-if="['nl-NL', 'nl-BE'].includes($i18n.locale)")
			weather-report(:weblog="weblog")
		template(slot="weathermap")
			v-radio-group.small.mb-3.mt-0(v-model="selectedMapType" row hide-details)
				v-radio(v-for="type in ['snowforecast', 'sun', 'snowradar', 'snowfall', 'temperature', 'wind', 'clouds']" :value="type" :key="type"  :label="$t(`page.resorts._resort.forecast:maps.types.${type}`)")
			interactive-weathermap(:type="selectedMapType" hide-borders hide-search :region="resort.area.measurepoints[0].forecastRegion == 'alps'? 'alps' : 'europe'" :area="resort.area.id" :rundate="$store.state.rundate")
		template(slot="checklist")
			v-row
				v-col(cols="12" md="8" v-if="['nl-NL', 'nl-BE'].includes($i18n.locale)")
					ws-checklist(:resort-id="resort.id")
				v-col(cols="12" md="4")
					snow-alarm(:initial-destination-id="resort.id" initial-destination-type="resort" :initial-destination-name="resort.name")
</template>

<script>
import gql from 'graphql-tag';
import InteractiveWeathermap from '@/components/weather/weathermap/interactive';
import WeatherReport from '@/components/weather-report.vue';
import ForecastTable from '@/components/weather/forecast-table.vue';
import MetaFragment from '@/components/graphql/metaFragment.graphql';

const forecastQuery = gql`
	query getResortForecast($path: String, $fallback: String, $slug: String!) {
		contentpage(path: $path, fallback: $fallback) {
			id
			name
			slug
			content {
				markdown
			}
			...MetaFragment
		}
		weblogsByCategory(limit: 1, category: "weather") {
			weblogs {
				id
				title
				slug
				content {
					introduction
				}
				publishDate
				url
				photo
				author {
					id
					username
					signature
					teamDescription
					role
				}
			}
		}
		resort(slug: $slug) {
			id
			name
			slug
			elevation
			country {
				id
				name
				countryCode
				slug
			}
			region {
				id
				name
				slug
			}
			geography {
				location {
					coordinates
				}
			}
			area {
				id
				slug
				name
				measurepoints {
					forecastRegion
				}
			}
		}
	}
	${MetaFragment}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/dorpen/:resort/weersverwachting',
			'de-DE': '/skiorte/:resort/wettervorhersage',
			'nl-BE': '/dorpen/:resort/weersverwachting'
		}
	},
	components: {
		InteractiveWeathermap,
		WeatherReport,
		ForecastTable
	},
	layout: 'default',
	asyncData({ params, app, route }) {
		return app.$graphClient
			.query({
				query: forecastQuery,
				variables: {
					slug: params.resort,
					path: route.path,
					fallback: route.path.replace(params.resort, '_resort')
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (!data.contentpage) {
					return app.httpError(404, null, 'resort-forecast-01', errors);
				}
				if (errors) {
					throw errors[0];
				}

				app.interpolater(data.contentpage.meta, ['title', 'description']);
				app.interpolater(data.contentpage.content, ['markdown']);
				app.interpolater(data.contentpage, ['name']);

				app.meta(data.contentpage.meta);
				app.ads({});
				app.resortBreadcrumbs(data.resort, {
					[app.i18n.t(`page.resorts._resort.forecast:breadcrumb`)]: {
						name: 'resorts-resort-forecast',
						params: { resort: data.resort.slug }
					}
				});

				return {
					...data
				};
			})
			.catch(app.$destinationNotFoundCatcher)
			.catch(error => {
				return app.httpError(500, null, 'resorts-resort-forecast-02', error);
			});
	},
	data() {
		return {
			selectedMapType: 'snowforecast'
		};
	},
	head() {
		return {
			...this.$structuredData()
		};
	},
	computed: {
		weblog() {
			return this.weblogsByCategory.weblogs[0];
		}
	},
	created() {
		this.$emit('update:showSidebar', false);
	},
	mounted() {
		if (window.location.hash) {
			for (const prop of window.location.hash.split('#')[1].split('-')) {
				if (isNaN(prop)) {
					this.selectedMapType = prop;
				}
			}
		}
	}
};
</script>
